import request from '@/utils/request'
import Qs from 'qs'
//获取支付方式
export function PaymentType(params) {
  return request({
    url: '/report/getPayType',
    method: 'get',
    params: params,
  })
}
//表头请求
export function ReportTbaleHaed(params) {
  return request({
    url: '/report/getSalesDayReportTbaleHaed',
    method: 'get',
    params: params,
  })
}

//获取分管
export function Inchargeof(params) {
  return request({
    url: '/venue/getStadium',
    method: 'get',
    params: params,
  })
}

//财务报表
export function FinancialList(params) {
  return request({
    url: 'report/getSalesDayReport',
    method: 'get',
    params: params,
  })
}
// http://192.168.1.98:8080/managementSystem/configFunction/getConfigInfo
export function login(params) {
  return request({
    url: 'land/login',
    method: 'post',
    params: params,
  })
}
//手机号登录
//POST /land/mobileLogin
export function mobileLogin(params) {
  return request({
    url: 'land/mobileLogin',
    method: 'post',
    params: params,
  })
}
//获取验证码
// GET /land/getVCode
export function getVCode(params) {
  return request({
    url: 'land/getVCode',
    method: 'get',
    params: params,
  })
}
//POST /land/getMenue
//查已分配权限
export function userGetMenue(params) {
  return request({
    url: '/user/getMenue',
    method: 'get',
    params: params,
  })
}
export function getConfigInfo(params) {
  return request({
    url: 'configFunction/getConfigInfo',
    method: 'get',
    params: params,
  })
}
//查询用户角色
// GET /user/getRoleByUser
export function usergetRoleByUser(params) {
  return request({
    url: 'user/getRoleByUser',
    method: 'get',
    params: params,
  })
}
//查询已经配置信息
// GET /configFunction/getFunctionNodeInfo
//configFunction/getClubDataSource
export function getFunctionNodeInfo(params) {
  return request({
    url: 'configFunction/getFunctionNodeInfo',
    method: 'get',
    params: params,
  })
}

//提交功能权限配置

//POST /configFunction/saveConfigInfo
export function saveConfigInfo(params) {
  return request({
    // headers: {'Content-Type':'multipart/form-data'},
    url: 'configFunction/saveConfigInfo',
    method: 'post',
    data: params,
  })
}
//POST /configFunction/getNoConfigClubDataSource
export function getNoConfigClubDataSource(params) {
  return request({
    // headers: {'Content-Type':'multipart/form-data'},
    url: 'configFunction/getNoConfigClubDataSource',
    method: 'post',
    data: params,
  })
}
//删除角色
// POST /employee/deleteRole
export function deleteRole(params) {
  return request({
    url: 'employee/deleteRole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//删除分店用户
//POST /employee/deleteUser
export function empldeleteUser(params) {
  return request({
    url: 'employee/deleteUser',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//修改用户角色
// POST /employee/updateUserRole
export function updateUserRole(params) {
  return request({
    url: 'employee/updateUserRole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询分店登录用户信息
//GET /employee/getUser
export function employeeGetUser(params) {
  return request({
    url: 'employee/getUser',
    method: 'get',
    params: params,
  })
}
//修改分店登录角色密码
//POST /employee/updatePassword
export function updatePassword(params) {
  return request({
    url: 'employee/updatePassword',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//新增分店用户角色
//POST /employee/insertRole
export function insertRole(params) {
  return request({
    url: 'employee/insertRole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询分店用户角色信息
//POST /employee/searchRole
export function searchRole(params) {
  return request({
    url: 'employee/searchRole',
    method: 'get',
    params: params,
  })
}
//修改分店角色信息
//POS /employee/updateRole
export function updateRole(params) {
  return request({
    url: 'employee/updateRole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//新增分店管理员角色
//POST /employee/insertAdmin
export function insertAdmin(params) {
  return request({
    url: 'employee/insertAdmin',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//新增登录用户信息
//POST /employee/insertUser
export function insertUser(params) {
  return request({
    url: 'employee/insertUser',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询后台所有权限
//get /employee/getMenue
export function getMenue(params) {
  return request({
    url: 'employee/getMenue',
    method: 'get',
    data: params,
  })
}
//勾选前台功能权限
//configFunction/addConfigInfo
export function addConfigInfo(params) {
  return request({
    url: 'configFunction/addConfigInfo',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//勾选菜单信息
//POST /employee/insertMenue
export function insertMenue(params) {
  return request({
    url: 'employee/insertMenue',
    method: 'post',
    data: Qs.stringify(params),
  })
}

//查询banner信息
// GET /configFunction/getBanner
export function getBanner(params) {
  return request({
    // headers: {'Content-Type':'multipart/form-data'},
    url: 'configFunction/getBanner',
    method: 'get',
    params: params,
  })
}
///////////////////////////////////////////////
//查询员工角色信息
//GET /infe/getInfERole
export function getInfERole(params) {
  return request({
    url: 'infe/getInfERole',
    method: 'get',
    params: params,
  })
}
// 修改员工信息
// POST /infe/updateRole
export function infeUpdateRole(params) {
  return request({
    url: 'infe/updateRole',
    method: 'post',
    params: params,
  })
}
//查询教练信息
//GET /infe/getEJtInfo
export function getEJtInfo(params) {
  return request({
    url: 'infe/getEJtInfo',
    method: 'get',
    params: params,
  })
}
//查询所有已上线私教
//GET /infe/getAllEJtInfo
export function getAllEJtInfo(params) {
  return request({
    url: 'infe/getAllEJtInfo',
    method: 'get',
    params: params,
  })
}
//修改教练信息
//POST /infe/updateEJtInfo
export function updateEJtInfo(params) {
  return request({
    url: 'infe/updateEJtInfo',
    method: 'get',
    params: params,
  })
}
///////////////////////////////////////////////////////////////
//查询数据源
// GET /dataSource/getDataSource
export function getDataSource(params) {
  return request({
    url: 'dataSource/getDataSource',
    method: 'get',
    params: params,
  })
}
//插入数据源
// POST /dataSource/addDataSource
export function addDataSource(params) {
  return request({
    url: 'dataSource/addDataSource',
    method: 'post',
    params: params,
  })
}
//修改数据源
// POST /dataSource/updateDataSource
export function updateDataSource(params) {
  return request({
    url: 'dataSource/updateDataSource',
    method: 'post',
    params: params,
  })
}
//增加功能节点
//POST /configFunction/insertFunctionNode
export function insertFunctionNode(params) {
  return request({
    url: 'configFunction/insertFunctionNode',
    method: 'post',
    params: params,
  })
}
//修改用户绑定手机号获取验证码
// /user/getVCode
export function UsergetVCode(params) {
  return request({
    url: 'user/getVCode',
    method: 'get',
    params: params,
  })
}

//添加用户角色
// POST /user/registUser
export function registUser(params) {
  return request({
    url: 'user/registUser',
    method: 'post',
    params: params,
  })
}
//获取用户角色列表
// GET /user/getRole
export function userGetrole(params) {
  return request({
    url: 'user/getRole',
    method: 'get',
    params: params,
  })
}
//删除用户
// POST /user/deleteUser
export function deleteUser(params) {
  return request({
    url: 'user/deleteUser',
    method: 'post',
    params: params,
  })
}
//修改角色信息
// POST /user/updateUser
export function updateUser(params) {
  return request({
    url: 'user/updateUser',
    method: 'post',
    params: params,
  })
}
//修改用户绑定手机号
// POST /user/updateUserMobile
export function updateUserMobile(params) {
  return request({
    url: 'user/updateUserMobile',
    method: 'post',
    params: params,
  })
}
//查询角色
//GET /user/getRole
export function getRole(params) {
  return request({
    url: 'user/getRole',
    method: 'get',
    params: params,
  })
}
//获取数据源来源列表
//GET /user/getClubMemberCodes
export function getClubMemberCodes(params) {
  return request({
    url: 'user/getClubMemberCodes',
    method: 'get',
    params: params,
  })
}
//查询用户账户
// GET /user/getUser
export function getUser(params) {
  return request({
    url: 'user/getUser',
    method: 'get',
    params: params,
  })
}

//票管理
//DELETE /ticket/getOnlineTicketInfo
export function getOnlineTicketInfo(params) {
  return request({
    url: 'ticket/getOnlineTicketInfo',
    method: 'get',
    params: params,
  })
}
//添加票
// POST /ticket/insertOnlineTicketInfo
export function insertOnlineTicketInfo(params) {
  return request({
    url: 'ticket/insertOnlineTicketInfo',
    method: 'post',
    params: params,
  })
}
//上、下线票
// POST /ticket/updateTicketInfo
export function updateTicketInfo(params) {
  return request({
    url: 'ticket/updateTicketInfo',
    method: 'post',
    params: params,
  })
}
//查询购票类型类表
//GET /ticket/getTicketType
export function getTicketType(params) {
  return request({
    url: 'ticket/getTicketType',
    method: 'get',
    params: params,
  })
}
//查询购票类型
//GET /ticket/getTicketTypes
export function getTicketTypes(params) {
  return request({
    url: 'ticket/getTicketTypes',
    method: 'get',
    params: params,
  })
}
//增加票类型
// POST /ticket/insertTicketType
export function insertTicketType(params) {
  return request({
    url: 'ticket/insertTicketType',
    method: 'post',
    params: params,
  })
}
//修改票类型
//POST /ticket/updateTicketType
export function updateTicketType(params) {
  return request({
    url: 'ticket/updateTicketType',
    method: 'post',
    params: params,
  })
}
///////////////////////////////////////////
//增加分店信息
// POST /venue/insertCustomerInfo
export function insertCustomerInfo(params) {
  return request({
    url: 'venue/insertCustomerInfo',
    method: 'post',
    params: params,
  })
}
//查询商家信息
// GET /venue/getCustomerInfo
export function getCustomerInfo(params) {
  return request({
    url: 'venue/getCustomerInfo',
    method: 'get',
    params: params,
  })
}
//查询分店
//GET /common/getShops
export function getShops(params) {
  return request({
    url: 'venue/getShops',
    method: 'get',
    params: params,
  })
}
//热门推荐查询卡列表
// GET /card/getCardsSells
export function getCardsSells(params) {
  return request({
    url: 'card/getCardsSells',
    method: 'get',
    params: params,
  })
}
///////////////////////////////////////
//卡模块
//查询卡列表
// GET /card/getCardsSell
export function getCardsSell(params) {
  return request({
    url: 'card/getCardsSell',
    method: 'get',
    params: params,
  })
}
//判断卡是否可以上线到改分店
// POST /card/cardAvailable
export function cardAvailable(params) {
  return request({
    url: 'card/cardAvailable',
    method: 'post',
    params: params,
  })
}
//查询会员卡可使用的分店
// POST /card/getTbShopsByCs
export function getTbShopsByCs(params) {
  return request({
    url: 'card/getTbShopsByCs',
    method: 'get',
    params: params,
  })
}
//增加卡
//POST /card/insertCardsSell
export function insertCardsSell(params) {
  return request({
    url: 'card/insertCardsSell',
    method: 'post',
    params: params,
  })
}
//修改线上卡种
// POST /card/updateCardsSell
export function updateCardsSell(params) {
  return request({
    url: 'card/updateCardsSell',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//删除卡模块
// POST /card/deletetOnlineCard
export function deletetOnlineCard(params) {
  return request({
    url: 'card/deletetOnlineCard',
    method: 'post',
    params: params,
  })
}
//查询线下卡种
//GET /card/getInfCs
export function getInfCs(params) {
  return request({
    url: 'card/getInfCs',
    method: 'get',
    params: params,
  })
}
//查询线下卡种--团课使用
//GET /tuanke/getInfCs
export function tuankeGetInfCs(params) {
  return request({
    url: 'tuanke/getInfCs',
    method: 'get',
    params: params,
  })
}
//修改线下图片
//GET /card/updateInfCsImgPath
export function updateInfCsImgPath(params) {
  return request({
    url: 'card/updateInfCsImgPath',
    method: 'get',
    params: params,
  })
}
// 查询购卡说明
// GET /card/getSaleCardExplanation
export function getSaleCardExplanation(params) {
  return request({
    url: 'card/getSaleCardExplanation',
    method: 'get',
    params: params,
  })
}
// 修改购卡说明
// POST /card/updateSaleCardExplanation
export function updateSaleCardExplanation(params) {
  return request({
    url: 'card/updateSaleCardExplanation',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询健康承诺书
// GET /healthCommitment/getHealthCommitment
export function getHealthCommitment(params) {
  return request({
    url: 'healthCommitment/getHealthCommitment',
    method: 'get',
    params: params,
  })
}
// 修改健康承诺书
// POST /healthCommitment/updateHealthCommitment
export function updateHealthCommitment(params) {
  return request({
    url: 'healthCommitment/updateHealthCommitment',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询快捷充值
// GET /card/getFastChongZhi
export function getFastChongZhi(params) {
  return request({
    url: 'card/getFastChongZhi',
    method: 'get',
    params: params,
  })
}
// 新增快捷充值
// POST /card/insertFastChongZhi
export function insertFastChongZhi(params) {
  return request({
    url: 'card/insertFastChongZhi',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 修改快捷充值
// POST /card/updateFastChongZhi
export function updateFastChongZhi(params) {
  return request({
    url: 'card/updateFastChongZhi',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 删除快捷充值
// POST /card/deleteFastChongZhi
export function deleteFastChongZhi(params) {
  return request({
    url: 'card/deleteFastChongZhi',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询充值返利
// GET /card/getRechargeRebate
export function getRechargeRebate(params) {
  return request({
    url: 'card/getRechargeRebate',
    method: 'get',
    params: params,
  })
}
// 增加充值返利
// POST /card/insertRechargeRebate
export function insertRechargeRebate(params) {
  return request({
    url: 'card/insertRechargeRebate',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 修改充值返利
// POST /card/updateRechargeRebate
export function updateRechargeRebate(params) {
  return request({
    url: 'card/updateRechargeRebate',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 上下架、删除充值返利
// POST /card/deleteRechargeRebate
export function deleteRechargeRebate(params) {
  return request({
    url: 'card/deleteRechargeRebate',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//获取私教教室
//POST /ptClass/getClassRoom
export function getClassRoom(params) {
  return request({
    url: 'ptClass/getClassRoom',
    method: 'post',
    params: params,
  })
}
//增加教室
// POST /ptClass/insertClassRoom
export function insertClassRoom(params) {
  return request({
    url: 'ptClass/insertClassRoom',
    method: 'post',
    params: params,
  })
}
//修改私教教室
// POST /ptClass/updateClassRoom
export function updateClassRoom(params) {
  return request({
    url: 'ptClass/updateClassRoom',
    method: 'post',
    params: params,
  })
}
//查询私教模块
// 、、get /ptClass/getInfI
export function getInfI(params) {
  return request({
    url: 'ptClass/getInfI',
    method: 'get',
    params: params,
  })
}
//GET /ptClass/getPtClass
// 查询已上线私教
export function getPtClass(params) {
  return request({
    url: 'ptClass/getPtClass',
    method: 'get',
    params: params,
  })
}
//上线私教
// POST /ptClass/insertTbPrivateCourse
export function insertTbPrivateCourse(params) {
  return request({
    url: 'ptClass/insertTbPrivateCourse',
    method: 'post',
    params: params,
  })
}
//删除线上私教
// POST /ptClass/deleteTbPrivateCourse
export function deleteTbPrivateCourse(params) {
  return request({
    url: 'ptClass/deleteTbPrivateCourse',
    method: 'post',
    params: params,
  })
}
//查询教练
// GET /tuanke/getVieWEJt
export function getVieWEJt(params) {
  return request({
    url: 'tuanke/getVieWEJt',
    method: 'get',
    params: params,
  })
}
//查询教室
// GET /tuanke/getClassInfo
export function getClassInfo(params) {
  return request({
    url: 'tuanke/getClassInfo',
    method: 'get',
    params: params,
  })
}
////////////////////////////////////
// GET /tuanke/getTbCourseType
// 查询团课类型目录
export function getTbCourseType(params) {
  return request({
    url: 'tuanke/getTbCourseType',
    method: 'get',
    params: params,
  })
}
//添加团课类型
//POST /tuanke/insertTbCourseType
export function insertTbCourseType(params) {
  return request({
    url: 'tuanke/insertTbCourseType',
    method: 'post',
    params: params,
  })
}
//修改团课类型
//POST /tuanke/updateTbCourseType
export function updateTbCourseType(params) {
  return request({
    url: 'tuanke/updateTbCourseType',
    method: 'post',
    params: params,
  })
}
//查询热门推荐选择团课项目
// GET /tuanke/getTbCourses
export function getTbCourses(params) {
  return request({
    url: 'tuanke/getTbCourses',
    method: 'get',
    params: params,
  })
}
//查询团课项目
// GET /tuanke/getTbCourse
export function getTbCourse(params) {
  return request({
    url: 'tuanke/getTbCourse',
    method: 'get',
    params: params,
  })
}
//新增团课项目
//POST /tuanke/insertTbCourse
export function insertTbCourse(params) {
  return request({
    url: 'tuanke/insertTbCourse',
    method: 'post',
    params: params,
  })
}
//修改团课项目
//POST /tuanke/updateTbCourse
export function updateTbCourse(params) {
  return request({
    url: 'tuanke/updateTbCourse',
    method: 'post',
    params: params,
  })
}
//查询排课列表
// GET /tuanke/getTbTuancaorec
export function getTbTuancaorec(params) {
  return request({
    url: 'tuanke/getTbTuancaorec',
    method: 'get',
    params: params,
  })
}
//增加排课
// POST /tuanke/insertTuancaorec
export function insertTuancaorec(params) {
  return request({
    url: 'tuanke/insertSomeTuancaorec',
    method: 'post',
    params: params,
  })
}
//修改排课
// POST /tuanke/updateTuancaorec
export function updateTuancaorec(params) {
  return request({
    url: 'tuanke/updateTuancaorec',
    method: 'post',
    params: params,
  })
}
////////////////////////
//场地管理
//查询线下项目
//GET /place/getInfI
export function placegetInfI(params) {
  return request({
    url: 'place/getInfI',
    method: 'get',
    params: params,
  })
}
//场地列表
//GET /place/getOnlinePlace
export function getOnlinePlace(params) {
  return request({
    url: 'place/getOnlinePlace',
    method: 'get',
    params: params,
  })
}
//POST /place/insertInfSt
//增加场地
export function insertInfSt(params) {
  return request({
    url: 'place/insertInfSt',
    method: 'post',
    params: params,
  })
}
//查询已经上线详细场地
//GET /place/getOnlinePlaceInfo
export function getOnlinePlaceInfo(params) {
  return request({
    url: 'place/getOnlinePlaceInfo',
    method: 'get',
    params: params,
  })
}
//POST /place/insertInfS
export function insertInfS(params) {
  return request({
    url: 'place/insertInfS',
    method: 'post',
    params: params,
  })
}
// POST /place/updateInfS
//修改场地明细
export function updateInfS(params) {
  return request({
    url: 'place/updateInfS',
    method: 'post',
    params: params,
  })
}
//////////////////////////////
//赛事记录
//GET /event/getEventHistory
//
export function getEventHistory(params) {
  return request({
    url: 'event/getEventHistory',
    method: 'get',
    params: params,
  })
}
//增加赛事记录
export function insertEventHistory(params) {
  return request({
    url: 'event/insertEventHistory',
    method: 'post',
    params: params,
  })
}
//修改赛事记录
// POST /event/updateEventHistory
export function updateEventHistory(params) {
  return request({
    url: 'event/updateEventHistory',
    method: 'post',
    params: params,
  })
}
//查询参赛团队信息
// GET /event/getEventMember
export function getEventMember(params) {
  return request({
    url: 'event/getEventMember',
    method: 'get',
    params: params,
  })
}

//查询消息配置模板列表
// GET /message/getTbPushMessageModel
export function getTbPushMessageModel(params) {
  return request({
    url: 'message/getTbPushMessageModel',
    method: 'get',
    params: params,
  })
}
//查询模板消息类型
// GET /message/getPushType
export function getPushType(params) {
  return request({
    url: 'message/getPushType',
    method: 'get',
    params: params,
  })
}
// 查询员工推送模板信息
// GET /message/getTbEPushMessageModel
export function getTbEPushMessageModel(params) {
  return request({
    url: 'message/getTbEPushMessageModel',
    method: 'get',
    params: params,
  })
}
//增加配置模板
///message/insertTbPushMessageModel
export function insertTbPushMessageModel(params) {
  return request({
    url: 'message/insertTbPushMessageModel',
    method: 'post',
    params: params,
  })
}
//增加消息推送员工配置模板
// POST /message/insertTbEPushMessageModel
export function insertTbEPushMessageModel(params) {
  return request({
    url: 'message/insertTbEPushMessageModel',
    method: 'post',
    params: params,
  })
}
//删除消息模板
//POST /message/deleteTbPushMessageModel
export function deleteTbPushMessageModel(params) {
  return request({
    url: 'message/deleteTbPushMessageModel',
    method: 'post',
    params: params,
  })
}
//删除员工推送模板信息
// POST /message/deleteTbEPushMessageModel
export function deleteTbEPushMessageModel(params) {
  return request({
    url: 'message/deleteTbEPushMessageModel',
    method: 'post',
    params: params,
  })
}
//修改消息推送模板
//POST /message/updateTbPushMessageModel
export function updateTbPushMessageModel(params) {
  return request({
    url: 'message/updateTbPushMessageModel',
    method: 'post',
    params: params,
  })
}
//修改员工推送模板信息
// POST /message/updateTbEPushMessageModel
export function updateTbEPushMessageModel(params) {
  return request({
    url: 'message/updateTbEPushMessageModel',
    method: 'post',
    params: params,
  })
}
//查询消息推送员工配置
//GET /message/getTbEPushMessage
export function getTbEPushMessage(params) {
  return request({
    url: 'message/getTbEPushMessage',
    method: 'get',
    params: params,
  })
}
//增加消息推送员工配置
//GET /message/insertTbEPushMessage
export function insertTbEPushMessage(params) {
  return request({
    url: 'message/insertTbEPushMessage',
    method: 'post',
    params: params,
  })
}
//查询员工信息
//GET /message/getInfE
export function getInfE(params) {
  return request({
    url: 'message/getInfE',
    method: 'get',
    params: params,
  })
}
//修改推送员工配置
//GET /message/updateTbEPushMessage
export function updateTbEPushMessage(params) {
  return request({
    url: 'message/updateTbEPushMessage',
    method: 'post',
    params: params,
  })
}
//删除推送员工消息
//GET /message/deleteTbEPushMessage
export function deleteTbEPushMessage(params) {
  return request({
    url: 'message/deleteTbEPushMessage',
    method: 'post',
    params: params,
  })
}
//查询已经上线的场地
// POST /place/getTbAppointConfig
export function getTbAppointConfig(params) {
  return request({
    url: 'place/getTbAppointConfig',
    method: 'post',
    params: params,
  })
}
//修改场地预约
//POST /place/updateTbAppointConfig
export function updateTbAppointConfig(params) {
  return request({
    url: 'place/updateTbAppointConfig',
    method: 'post',
    params: params,
  })
}
//增加预约取消信息
//POST /place/insertTbAppointConfig
export function insertTbAppointConfig(params) {
  return request({
    url: 'place/insertTbAppointConfig',
    method: 'post',
    params: params,
  })
}
//查询已经上线票的预约信息
// POST /place/getTbAppointConfig
export function ticketGetTbAppointConfig(params) {
  return request({
    url: 'ticket/getTbAppointConfig',
    method: 'post',
    params: params,
  })
}
//增加预约取消票信息
//POST /ticket/insertTbAppointConfig
export function tickeTinsertTbAppointConfig(params) {
  return request({
    url: 'ticket/insertTbAppointConfig',
    method: 'post',
    params: params,
  })
}
//修改票预约
//POST /ticket/updateTbAppointConfig
export function tickeTupdateTbAppointConfig(params) {
  return request({
    url: 'ticket/updateTbAppointConfig',
    method: 'post',
    params: params,
  })
}
//查询退款记录
// /operate/getRefundRecords
export function getRefundRecords(params) {
  return request({
    url: 'operate/getRefundRecords',
    method: 'get',
    params: params,
  })
}
//修改退款记录
//POST /operate/updateRefundRecords
export function updateRefundRecords(params) {
  return request({
    url: 'operate/updateRefundRecords',
    method: 'post',
    params: params,
  })
}
//删除票预约规则
//POST /ticket/deleteTbAppointConfig
export function deleteTbAppointConfig(params) {
  return request({
    url: 'ticket/deleteTbAppointConfig',
    method: 'post',
    params: params,
  })
}
//删除票预约规则
//POST /place/placeDeleteTbAppointConfig
export function placeDeleteTbAppointConfig(params) {
  return request({
    url: 'place/deleteTbAppointConfig',
    method: 'post',
    params: params,
  })
}
// 查询购票说明
// GET /ticket/getSaleTicketExplanation
export function getSaleTicketExplanation(params) {
  return request({
    url: '/ticket/getSaleTicketExplanation',
    method: 'get',
    params: params,
  })
}
// 修改购票说明
// POST /ticket/updateSaleTicketExplanation
export function updateSaleTicketExplanation(params) {
  return request({
    url: 'ticket/updateSaleTicketExplanation',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询教练休息时间
//GET /infe/getEBreakTime
export function getEBreakTime(params) {
  return request({
    url: '/infe/getEBreakTime',
    method: 'get',
    params: params,
  })
}
//增加教练休息时间
//POST /infe/insertEBreakTime
export function insertEBreakTime(params) {
  return request({
    url: '/infe/insertEBreakTime',
    method: 'post',
    params: params,
  })
}
//推荐模块
// GET /recommend/getRecommendType
export function getRecommendType(params) {
  return request({
    url: '/recommend/getRecommendType',
    method: 'get',
    params: params,
  })
}
//修改类型推荐配置
// POST /recommend/updateRecommendType
export function updateRecommendType(params) {
  return request({
    url: '/recommend/updateRecommendType',
    method: 'post',
    params: params,
  })
}
//查询推荐配置信息
//GET /recommend/getRecommendinfo
export function getRecommendinfo(params) {
  return request({
    url: '/recommend/getRecommendinfo',
    method: 'get',
    params: params,
  })
}
//增加推荐配置信息
//POST /recommend/inserteRecommendinfo
export function inserteRecommendinfo(params) {
  return request({
    url: '/recommend/inserteRecommendinfo',
    method: 'post',
    params: params,
  })
}
//同步推荐配置数据
//POST /recommend/insertRecommendType
export function insertRecommendType(params) {
  return request({
    url: '/recommend/insertRecommendType',
    method: 'post',
    params: params,
  })
}
// 查询线上私教去重
// // GET /ptClass/getPrivateCourse
export function getPrivateCourse(params) {
  return request({
    url: '/ptClass/getPrivateCourse',
    method: 'get',
    params: params,
  })
}
//删除推荐配置信息
// POST /recommend/deleteRecommendinfo
export function deleteRecommendinfo(params) {
  return request({
    url: '/recommend/deleteRecommendinfo',
    method: 'post',
    params: params,
  })
}
//支付设置查询
// GET /pay/getPayConfig
export function getPayConfig(params) {
  return request({
    url: '/pay/getPayConfig',
    method: 'get',
    params: params,
  })
}
// 增加微信支付配置
export function insertWxPayConfig(params) {
  return request({
    url: '/pay/insertWxPayConfig',
    method: 'post',
    params: params,
  })
}
// 增加微信支付配置
//POST /pay/insertZFBPayConfig
export function insertZFBPayConfig(params) {
  return request({
    url: '/pay/insertZFBPayConfig',
    method: 'post',
    params: params,
  })
}
// 修改微信支付设置
//POST /pay/updateWxPayConfig
export function updateWxPayConfig(params) {
  return request({
    url: '/pay/updateWxPayConfig',
    method: 'post',
    params: params,
  })
}
// 修改支付宝支付设置
//POST /pay/updateZFBPayConfig
export function updateZFBPayConfig(params) {
  return request({
    url: '/pay/updateZFBPayConfig',
    method: 'post',
    params: params,
  })
}
// 删除支付设置
//POST /pay/deletePayConfig
export function deletePayConfig(params) {
  return request({
    url: '/pay/deletePayConfig',
    method: 'post',
    params: params,
  })
}

//查询短信配置
export function selectSmsMessage(params) {
  return request({
    url: 'configFunction/selectSmsMessage',
    method: 'get',
    params: params,
  })
}
//修改短信配置
export function updateSmsMessage(params) {
  return request({
    url: 'configFunction/updateSmsMessage',
    method: 'post',
    params: params,
  })
}
//新增短信配置
export function insertSmsMessage(params) {
  return request({
    url: 'configFunction/insertSmsMessage',
    method: 'post',
    params: params,
  })
}
//删除短信配置
export function deleteSmsMessage(params) {
  return request({
    url: 'configFunction/deleteSmsMessage',
    method: 'post',
    params: params,
  })
}

//查询卡可使用的分店
// GET /card/getTbShopsByCs
export function getCardShopList(params) {
  return request({
    url: '/card/getTbShopsByCs',
    method: 'get',
    params: params,
  })
}
// 查询菜单配置列表
//GET /configFunction/serachMenu
export function serachMenu(params) {
  return request({
    url: 'configFunction/serachMenu',
    method: 'get',
    params: params,
  })
}
// 修改导航配置
// GET /configFunction/updateMenu
export function updateMenu(params) {
  return request({
    url: 'configFunction/updateMenu',
    method: 'post',
    params: params,
  })
}
//新增导航配置
// POST /configFunction/insertMenu
export function insertMenu(params) {
  return request({
    url: 'configFunction/insertMenu',
    method: 'post',
    params: params,
  })
}
//查询已选择导航栏配置
//GET /configFunction/serachChooseMenu
export function serachChooseMenu(params) {
  return request({
    url: 'configFunction/serachChooseMenu',
    method: 'get',
    params: params,
  })
}
//删除导航栏配置
//POST /configFunction/deleteMenu
export function deleteMenu(params) {
  return request({
    url: 'configFunction/deleteMenu',
    method: 'post',
    params: params,
  })
}

//操作日志
//GET /log/getLogs
export function getLogs(params) {
  return request({
    url: 'log/getLogs',
    method: 'get',
    params: params,
  })
}

//营销模块
//限时折扣
// GET /discounttype/getDiscountAll
export function getDiscountAll(params) {
  return request({
    url: 'discounttype/getDiscountAll',
    method: 'get',
    params: params,
  })
}
//获取产品类型
//GET /discounttype/getProductType
export function getProductType(params) {
  return request({
    url: 'discounttype/getProductType',
    method: 'get',
    params: params,
  })
}
//查询私教课
//GET /discounttype/getSJCourse
export function getSJCourse(params) {
  return request({
    url: 'discounttype/getSJCourse',
    method: 'get',
    params: params,
  })
}
//查询已上线私教信息内部优惠使用
//GET /ptClass/getPtClassInfo
export function getPtClassInfo(params) {
  return request({
    url: 'ptClass/getPtClassInfo',
    method: 'get',
    params: params,
  })
}
//查询根据课程查教练
// GET /discounttype/getCoachByCourseId
export function getCoachByCourseId(params) {
  return request({
    url: 'discounttype/getCoachByCourseId',
    method: 'get',
    params: params,
  })
}
//根据选择类型查询卡类型
// GET /discounttype/getCardType
export function getCardType(params) {
  return request({
    url: 'discounttype/getCardType',
    method: 'get',
    params: params,
  })
}
//查询门票
//GET /discounttype/getWxTicket
export function getWxTicket(params) {
  return request({
    url: 'discounttype/getWxTicket',
    method: 'get',
    params: params,
  })
}
//查询场地
//GET /discounttype/getSite
export function getSite(params) {
  return request({
    url: 'discounttype/getSite',
    method: 'get',
    params: params,
  })
}
//查询培训项目
//GET /discounttype/getTrainCourse
export function getTrainCourse(params) {
  return request({
    url: 'discounttype/getTrainCourse',
    method: 'get',
    params: params,
  })
}
//查询场地详情
//GET /discounttype/getSiteInfo
export function getSiteInfo(params) {
  return request({
    url: 'discounttype/getSiteInfo',
    method: 'get',
    params: params,
  })
}
//添加限时折扣
//POST /discounttype/addDiscountGoods
export function addDiscountGoods(params) {
  return request({
    url: 'discounttype/addDiscountGoods',
    method: 'post',
    params: params,
  })
}
//限时折扣上线
//GET /discounttype/openDiscountGoods
export function openDiscountGoods(params) {
  return request({
    url: 'discounttype/openDiscountGoods',
    method: 'get',
    params: params,
  })
}
//限时折扣下线
// GET /discounttype/closeDiscountGoods
export function closeDiscountGoods(params) {
  return request({
    url: 'discounttype/closeDiscountGoods',
    method: 'get',
    params: params,
  })
}
//删除限时折扣
//GET /discounttype/deleteDiscountGoods
export function deleteDiscountGoods(params) {
  return request({
    url: 'discounttype/deleteDiscountGoods',
    method: 'get',
    params: params,
  })
}
//查询所有优惠券
//GET /discount/getTbDiscount
export function getTbDiscount(params) {
  return request({
    url: 'discount/getTbDiscount',
    method: 'get',
    params: params,
  })
}
//添加优惠券
//POST /discount/addTbDiscount
export function addTbDiscount(params) {
  return request({
    url: 'discount/addTbDiscount',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//上线，下线，删除，优惠券
//GET /discount/updateStates
export function updateStates(params) {
  return request({
    url: 'discount/updateStates',
    method: 'get',
    params: params,
  })
}
//删除优惠券
// GET /discount/deleteStates
export function deleteStates(params) {
  return request({
    url: 'discount/deleteStates',
    method: 'get',
    params: params,
  })
}
//查询所有签到奖品
//GET /discountaward/getDiscountAwardAll
export function getDiscountAwardAll(params) {
  return request({
    url: 'discountaward/getDiscountAwardAll',
    method: 'get',
    params: params,
  })
}

//获取优惠券
// GET /discount/getDiscountType
//
export function getDiscountType(params) {
  return request({
    url: 'discount/getDiscountType',
    method: 'get',
    params: params,
  })
}
//添加签到领好礼
//POST /discountaward/addDiscountAward
export function addDiscountAward(params) {
  return request({
    url: 'discountaward/addDiscountAward',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//签到领好礼上线下线操作
// GET /discountaward/updateDiscountAwardStuats
export function updateDiscountAwardStuats(params) {
  return request({
    url: 'discountaward/updateDiscountAwardStuats',
    method: 'get',
    params: params,
  })
}

//删除签到领好礼
// GET /discountaward/deleteDiscountAward
export function deleteDiscountAward(params) {
  return request({
    url: 'discountaward/deleteDiscountAward',
    method: 'get',
    params: params,
  })
}
//大转盘设置
// POST /takeaward/addTakeawardSetting
export function addTakeawardSetting(params) {
  return request({
    url: 'takeaward/addTakeawardSetting',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询抽奖活动
//GET /takeaward/getTakeawardSetting
export function getTakeawardSetting(params) {
  return request({
    url: 'takeaward/getTakeawardSetting',
    method: 'get',
    params: params,
  })
}
//上/下线抽奖活动
//GET /takeaward/updateTakewardStuats
export function updateTakewardStuats(params) {
  return request({
    url: 'takeaward/updateTakewardStuats',
    method: 'get',
    params: params,
  })
}
//删除当前活动
//GET /takeaward/deleteTakeawardSetting
export function deleteTakeawardSetting(params) {
  return request({
    url: 'takeaward/deleteTakeawardSetting',
    method: 'get',
    params: params,
  })
}
//GET /takeaward/getGradeNum
// 查询奖品等级
export function getGradeNum(params) {
  return request({
    url: 'takeaward/getGradeNum',
    method: 'get',
    params: params,
  })
}
//添加大转盘抽奖
//POST /takeaward/addTakeaward
export function addTakeaward(params) {
  return request({
    url: 'takeaward/addTakeaward',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询活动奖品
//GET /takeaward/getTbTakeawardAll
export function getTbTakeawardAll(params) {
  return request({
    url: 'takeaward/getTbTakeawardAll',
    method: 'get',
    params: params,
  })
}
//删除活动奖品
//GET /takeaward/deleteTbTakeawardById
export function deleteTbTakeawardById(params) {
  return request({
    url: 'takeaward/deleteTbTakeawardById',
    method: 'get',
    params: params,
  })
}
//查询员工所有配置信息
// GET /configFunction/getEmployeeCanConfigInfo
export function getEmployeeCanConfigInfo(params) {
  return request({
    url: 'configFunction/getEmployeeCanConfigInfo',
    method: 'get',
    params: params,
  })
}

//查询员工已配置信息
//GET /configFunction/getEmployeeConfigInfo
export function getEmployeeConfigInfo(params) {
  return request({
    url: 'configFunction/getEmployeeConfigInfo',
    method: 'get',
    params: params,
  })
}
//新增员工配置功能
//POST /configFunction/insertEmployeeConfigInfo
export function insertEmployeeConfigInfo(params) {
  return request({
    url: 'configFunction/insertEmployeeConfigInfo',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//新增员工功能呢节点
// POST /configFunction/insertEFunctionNode
export function insertEFunctionNode(params) {
  return request({
    url: 'configFunction/insertEFunctionNode',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//新增员工角色
//POST /infe/insertERole
export function insertERole(params) {
  return request({
    url: 'infe/insertERole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//修改员工角色
//POST /infe/updateEUserRole
export function updateEUserRole(params) {
  return request({
    url: 'infe/updateEUserRole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//修改员工角色信息
//GET /infe/updateInfERole
export function updateInfERole(params) {
  return request({
    url: 'infe/updateInfERole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//删除员工信息
//post /infe/deletefERole
export function deletefERole(params) {
  return request({
    url: 'infe/deletefERole',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询所有员工信息
///infe/getInfEInfo
export function getInfEInfo(params) {
  return request({
    url: 'infe/getInfEInfo',
    method: 'get',
    params: params,
  })
}
//查询员工密码
// POST /infe/updateEUserPassword
export function updateEUserPassword(params) {
  return request({
    url: 'infe/updateEUserPassword',
    method: 'post',
    params: params,
  })
}
//查询会员特权奖励
//GET /privilete/findPrivileteAwardAll
export function findPrivileteAwardAll(params) {
  return request({
    url: 'privilete/findPrivileteAwardAll',
    method: 'get',
    params: params,
  })
}
//查询会员特权类型
//GET /privilete/getPrivileteType
export function getPrivileteType(params) {
  return request({
    url: 'privilete/getPrivileteType',
    method: 'get',
    params: params,
  })
}
//添加修改会员特权
// POST /privilete/addOrUpdatePrivileteAward
export function addOrUpdatePrivileteAward(params) {
  return request({
    url: 'privilete/addOrUpdatePrivileteAward',
    method: 'post',
    params: params,
  })
}
//上下线会员特权
// GET /privilete/updatePrivileteAwarStuats
export function updatePrivileteAwarStuats(params) {
  return request({
    url: 'privilete/updatePrivileteAwarStuats',
    method: 'get',
    params: params,
  })
}
//删除会员特权数据
//GET /privilete/deletePrivileteAward
export function deletePrivileteAward(params) {
  return request({
    url: 'privilete/deletePrivileteAward',
    method: 'get',
    params: params,
  })
}
//查询指定会员数据
// GET /privilete/getPrivileteAssign
export function getPrivileteAssign(params) {
  return request({
    url: 'privilete/getPrivileteAssign',
    method: 'get',
    params: params,
  })
}
//查询会员指定信息
// GET /privilete/getUserByMobile
export function getUserByMobile(params) {
  return request({
    url: 'privilete/getUserByMobile',
    method: 'get',
    params: params,
  })
}

//查询发送给指定会员
//GET /privilete/sendPrivileteAssignUser
export function sendPrivileteAssignUser(params) {
  return request({
    url: 'privilete/sendPrivileteAssignUser',
    method: 'get',
    params: params,
  })
}
//添加或修改指定会员奖励
// POST /privilete/addOrUpdatePrivileteAssign
export function addOrUpdatePrivileteAssign(params) {
  return request({
    url: 'privilete/addOrUpdatePrivileteAssign',
    method: 'post',
    params: params,
  })
}

//查询积分规则
//GET /integral/getIntegralRule
export function getIntegralRule(params) {
  return request({
    url: 'integral/getIntegralRule',
    method: 'get',
    params: params,
  })
}
//添加修改积分规则
// POST /integral/addOrUpdateIntegralRule
export function addOrUpdateIntegralRule(params) {
  return request({
    url: 'integral/addOrUpdateIntegralRule',
    method: 'post',
    params: params,
  })
}
//删除积分规则
//GET /integral/deleteIntegralRule
export function deleteIntegralRule(params) {
  return request({
    url: 'integral/deleteIntegralRule',
    method: 'get',
    params: params,
  })
}
//查询积分任务类型
//GET /integral/getIntegralSpec
export function getIntegralSpec(params) {
  return request({
    url: 'integral/getIntegralSpec',
    method: 'get',
    params: params,
  })
}
//添加修改积分任务
//POST /integral/addOrUpdateTbIntegralTask
export function addOrUpdateTbIntegralTask(params) {
  return request({
    url: 'integral/addOrUpdateTbIntegralTask',
    method: 'post',
    params: params,
  })
}
//查询积分任务
// GET /integral/getIntegralTaskAll
export function getIntegralTaskAll(params) {
  return request({
    url: 'integral/getIntegralTaskAll',
    method: 'get',
    params: params,
  })
}
//上线下线积分任务
//GET /integral/updateTaskStuats
export function updateTaskStuats(params) {
  return request({
    url: 'integral/updateTaskStuats',
    method: 'get',
    params: params,
  })
}
//GET /integral/deleteIntegralTask
export function deleteIntegralTask(params) {
  return request({
    url: 'integral/deleteIntegralTask',
    method: 'get',
    params: params,
  })
}
//获取配置的兑换物品
//GET /integral/getTbIntegralConvertAll
export function getTbIntegralConvertAll(params) {
  return request({
    url: 'integral/getTbIntegralConvertAll',
    method: 'get',
    params: params,
  })
}
//上下线兑换物品
//GET /integral/updateStuats
export function updateStuats(params) {
  return request({
    url: 'integral/updateStuats',
    method: 'get',
    params: params,
  })
}
//删除积分兑换商品
//GET /integral/deleteIntegralConvert
export function deleteIntegralConvert(params) {
  return request({
    url: 'integral/deleteIntegralConvert',
    method: 'get',
    params: params,
  })
}
//查询登录图片信息
// 、、GET /venue/getLoginImagefo
export function getLoginImagefo(params) {
  return request({
    url: 'venue/getLoginImagefo',
    method: 'get',
    params: params,
  })
}
//修改登录图片信息

//POST /venue/updateLoginImagefo
export function updateLoginImagefo(params) {
  return request({
    url: 'venue/updateLoginImagefo',
    method: 'post',
    params: params,
  })
}
//查询考勤组
//GET /attendanceGroup/getAllGroups
export function getAllGroups(params) {
  return request({
    url: '/attendanceGroup/getAllGroups',
    method: 'get',
    params: params,
  })
}
//查看考勤组详细信息
//GET /attendanceGroup/getGroupsInfo
export function getGroupsInfo(params) {
  return request({
    url: '/attendanceGroup/getGroupsInfo',
    method: 'get',
    params: params,
  })
}
//获取考勤类型
//GET /attendanceGroup/getAttendanceType
export function getAttendanceType(params) {
  return request({
    url: '/attendanceGroup/getAttendanceType',
    method: 'get',
    params: params,
  })
}

//新增考勤组成员
//POST /attendanceGroup/addCheckGroup
export function addCheckGroup(params) {
  return request({
    url: '/attendanceGroup/addCheckGroup',
    method: 'post',
    params: params,
  })
}
//删除考勤组
// POST /attendanceGroup/deleteGroupEmp
export function deleteGroupEmp(params) {
  return request({
    url: '/attendanceGroup/deleteGroupEmp',
    method: 'post',
    params: params,
  })
}
//修改考勤组信息
// POST /attendanceGroup/modifyCheckGroup
export function modifyCheckGroup(params) {
  return request({
    url: '/attendanceGroup/modifyCheckGroup',
    method: 'post',
    params: params,
  })
}
//添加考勤组成员
//POST /attendanceGroup/addGroupMember
export function addGroupMember(params) {
  return request({
    url: '/attendanceGroup/addGroupMember',
    method: 'post',
    params: params,
  })
}
//删除考勤组人员
//POST /attendanceGroup/deleteGroupMember
export function deleteGroupMember(params) {
  return request({
    url: '/attendanceGroup/deleteGroupMember',
    method: 'post',
    params: params,
  })
}
//查看考勤组成员
// 、、GET /attendanceGroup/getGroupEmp
export function getGroupEmp(params) {
  return request({
    url: '/attendanceGroup/getGroupEmp',
    method: 'get',
    params: params,
  })
}
//获取考勤班次
//GET /attendanceGroup/getSchduleType
export function getSchduleType(params) {
  return request({
    url: '/attendanceGroup/getSchduleType',
    method: 'get',
    params: params,
  })
}
//设置班次类型
//POST /attendanceGroup/addSchduleType
export function addSchduleType(params) {
  return request({
    url: '/attendanceGroup/addSchduleType',
    method: 'post',
    params: params,
  })
}
//修改班次信息
//POST /attendanceGroup/modifySchdule
export function modifySchdule(params) {
  return request({
    url: '/attendanceGroup/modifySchdule',
    method: 'post',
    params: params,
  })
}
//删除分店班次信息
//POST /attendanceGroup/deleteSchdule
export function deleteSchdule(params) {
  return request({
    url: '/attendanceGroup/deleteSchdule',
    method: 'post',
    params: params,
  })
}
//添加考勤详细信息
// 、、POST /attendanceGroup/addGroupOptions
export function addGroupOptions(params) {
  return request({
    url: '/attendanceGroup/addGroupOptions',
    method: 'post',
    params: params,
  })
}
//修改详细信息
// 、、POST /attendanceGroup/modifyGroupOptions
export function modifyGroupOptions(params) {
  return request({
    url: '/attendanceGroup/modifyGroupOptions',
    method: 'post',
    params: params,
  })
}
//获取所有分店考勤地址
// 、、GET /attendanceGroup/getLocation
export function getLocation(params) {
  return request({
    url: '/attendanceGroup/getLocation',
    method: 'get',
    params: params,
  })
}
//设置考勤地点
//POST /attendanceGroup/setLocation
export function setLocation(params) {
  return request({
    url: '/attendanceGroup/setLocation',
    method: 'post',
    params: params,
  })
}
//修改考勤地点
//POST /attendanceGroup/modifyLocation
export function modifyLocation(params) {
  return request({
    url: '/attendanceGroup/modifyLocation',
    method: 'post',
    params: params,
  })
}
//删除考勤地点
//POST /attendanceGroup/deleteLocation
export function deleteLocation(params) {
  return request({
    url: '/attendanceGroup/deleteLocation',
    method: 'post',
    params: params,
  })
}
//查询场地公用数量
//GET /place/getCommonSizePlace
export function getCommonSizePlace(params) {
  return request({
    url: '/place/getCommonSizePlace',
    method: 'get',
    params: params,
  })
}
// 修改多片场地公用预约量
// 、、GET /place/updateCommonSizePlace
export function updateCommonSizePlace(params) {
  return request({
    url: '/place/updateCommonSizePlace',
    method: 'post',
    params: params,
  })
}
//删除多片场地公用预约量
//POST /place/deleteCommonSizePlace
export function deleteCommonSizePlace(params) {
  return request({
    url: '/place/deleteCommonSizePlace',
    method: 'post',
    params: params,
  })
}
export function updateShopsInfo(params) {
  return request({
    url: '/venue/updateShopsInfo',
    method: 'post',
    params: params,
  })
}
//查看项目阈值
// get /threshold/getThreshold
export function getThreshold(params) {
  return request({
    url: '/threshold/getThreshold',
    method: 'get',
    params: params,
  })
}
// 设置阈值
// POST /threshold/setThreshold
export function setThreshold(params) {
  return request({
    url: '/threshold/setThreshold',
    method: 'post',
    params: params,
  })
}
//查询商品品牌
// GET /threshold/getBrand
export function getBrand(params) {
  return request({
    url: '/threshold/getBrand',
    method: 'get',
    params: params,
  })
}
//查询商品分类
// GET /threshold/getCategory
export function getCategory(params) {
  return request({
    url: '/threshold/getCategory',
    method: 'get',
    params: params,
  })
}
//查询所有库存商品
// GET /threshold/getRepertoryGoods
export function getRepertoryGoods(params) {
  return request({
    url: '/threshold/getRepertoryGoods',
    method: 'get',
    params: params,
  })
}
// 设置库存商品阈值
// POST /threshold/setThresholdValue
export function setThresholdValue(params) {
  return request({
    url: '/threshold/setThresholdValue',
    method: 'post',
    params: params,
  })
}
// 查询团课项目名称列表
// get /tuanke/selectTbcourse
export function selectTbcourse(params) {
  return request({
    url: '/tuanke/selectTbcourse',
    method: 'get',
    params: params,
  })
}
// 查询团课项目惩罚规则
// GET /tuanke/getTbCoursePenaltyRules
export function getTbCoursePenaltyRules(params) {
  return request({
    url: '/tuanke/getTbCoursePenaltyRules',
    method: 'get',
    params: params,
  })
}
// 删除团课项目惩罚规则
// GET /tuanke/deleteTbCoursePenaltyRules
export function deleteTbCoursePenaltyRules(params) {
  return request({
    url: '/tuanke/deleteTbCoursePenaltyRules',
    method: 'get',
    params: params,
  })
}
// 修改团课项目惩罚规则
// POST /tuanke/updateTbCoursePenaltyRules
export function updateTbCoursePenaltyRules(params) {
  return request({
    url: '/tuanke/updateTbCoursePenaltyRules',
    method: 'post',
    params: params,
  })
}
// 查询会籍/教练主管下的人员信息
// GET /infe/getSupervisor
export function getSupervisor(params) {
  return request({
    url: '/infe/getSupervisor',
    method: 'get',
    params: params,
  })
}
// 给会籍/教练主管添加他手下的会籍/教练
// POST /infe/insertSupervisor
export function insertSupervisor(params) {
  return request({
    url: '/infe/insertSupervisor',
    method: 'post',
    params: params,
  })
}
// 查询会籍/教练信息
// GET /infe/getE
export function getE(params) {
  return request({
    url: '/infe/getE',
    method: 'get',
    params: params,
  })
}
// 查看物业管理上报记录
// GET /property/getProblemReport
export function getProblemReport(params) {
  return request({
    url: '/property/getProblemReport',
    method: 'get',
    params: params,
  })
}
// 修改物业上报的状态
// POST /property/updateStatus
export function updateStatus(params) {
  return request({
    url: '/property/updateStatus',
    method: 'post',
    params: params,
  })
}
// 查询已发布培训报名信息
// GET /train/getTrainInfo
export function getTrainInfo(params) {
  return request({
    url: '/train/getTrainInfo',
    method: 'get',
    params: params,
  })
}
// 培训报名信息上下线
// POST /train/updateTrainInfoType
export function updateTrainInfoType(params) {
  return request({
    url: '/train/updateTrainInfoType',
    method: 'post',
    params: params,
  })
}
// 查询报名情况
// GET /train/getTrainUser
export function getTrainUser(params) {
  return request({
    url: '/train/getTrainUser',
    method: 'get',
    params: params,
  })
}
// 查询员工推送类型
//GET /message/getTbEPushType
export function getTbEPushType(params) {
  return request({
    url: 'message/getTbEPushType',
    method: 'get',
    params: params,
  })
}
// 查询会员卡购票限制
// GET /ticket/getTbCardTicket
export function getTbCardTicket(params) {
  return request({
    url: '/ticket/getTbCardTicket',
    method: 'get',
    params: params,
  })
}
// 增加会员卡购票限制
// POST /ticket/insertTbCardTicket
export function insertTbCardTicket(params) {
  return request({
    url: '/ticket/insertTbCardTicket',
    method: 'post',
    params: params,
  })
}
// 修改会员卡购票限制
// POST /ticket/updateTbCardTicket
export function updateTbCardTicket(params) {
  return request({
    url: '/ticket/updateTbCardTicket',
    method: 'post',
    params: params,
  })
}
// 删除会员卡购票限制
// POST /ticket/deleteTbCardTicket
export function deleteTbCardTicket(params) {
  return request({
    url: '/ticket/deleteTbCardTicket',
    method: 'post',
    params: params,
  })
}
// 查询商户打款列表
// GET /meituanBills/getPaymentList
export function getPaymentList(params) {
  return request({
    url: '/meituanBills/getPaymentList',
    method: 'get',
    params: params,
  })
}
// 查询新的商户打款列表
// GET /meituanBills/getNewPaymentList
export function getNewPaymentList(params) {
  return request({
    url: '/meituanBills/getNewPaymentList',
    method: 'get',
    params: params,
  })
}
// 新增商户
// POST /meituanBills/addMerchant
export function addMerchant(params) {
  return request({
    url: '/meituanBills/addMerchant',
    method: 'post',
    params: params,
  })
}
// 查询商户
// GET /meituanBills/getMerchant
export function getMerchant(params) {
  return request({
    url: '/meituanBills/getMerchant',
    method: 'get',
    params: params,
  })
}
// 修改删除商户
// POST /meituanBills/modifyMerchant
export function modifyMerchant(params) {
  return request({
    url: '/meituanBills/modifyMerchant',
    method: 'post',
    params: params,
  })
}
// 根据打款id查询结算明细
// GET /meituanBills/getPaymentListDetail
export function getPaymentListDetail(params) {
  return request({
    url: '/meituanBills/getPaymentListDetail',
    method: 'get',
    params: params,
  })
}
// 判断退款是否需要验证
// POST /meituanBills/isVerify
export function isVerify(params) {
  return request({
    url: '/meituanBills/isVerify',
    method: 'post',
    params: params,
  })
}
// 美团退款操作
// POST /meituanBills/meituanRefund
export function meituanRefund(params) {
  return request({
    url: '/meituanBills/meituanRefund',
    method: 'post',
    params: params,
  })
}
// 美团获取员工配置
// GET /meituanBills/getMeiTuanEmp
export function getMeiTuanEmp(params) {
  return request({
    url: '/meituanBills/getMeiTuanEmp',
    method: 'get',
    params: params,
  })
}
// 美团新增员工配置
// POST /meituanBills/addMeiTuanEmp
export function addMeiTuanEmp(params) {
  return request({
    url: '/meituanBills/addMeiTuanEmp',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 美团修改删除员工配置
// POST /meituanBills/updateMeiTuanEmp
export function updateMeiTuanEmp(params) {
  return request({
    url: '/meituanBills/updateMeiTuanEmp',
    method: 'post',
    data: Qs.stringify(params),
  })
}

// 培训班相关
//分页查询培训班类型
//GET /train/getPageTrainType
export function getPageTrainType(params) {
  return request({
    url: '/train/getPageTrainType',
    method: 'get',
    params: params,
  })
}
//查询培训班类型
//GET /train/getTrainType
export function getTrainType(params) {
  return request({
    url: '/train/getTrainType',
    method: 'get',
    params: params,
  })
}
// 新增培训班类型
// POST /train/insertTrainType
export function insertTrainType(params) {
  return request({
    url: '/train/insertTrainType',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 修改培训班类型
// POST /train/updateTrainType
export function updateTrainType(params) {
  return request({
    url: '/train/updateTrainType',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 删除培训班类型
// POST /train/deletTrainType
export function deletTrainType(params) {
  return request({
    url: '/train/deletTrainType',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询培训班项目
// GET /train/getTrainProject
export function getTrainProject(params) {
  return request({
    url: '/train/getTrainProject',
    method: 'get',
    params: params,
  })
}
// 培训班项目上下线
// POST /train/trainProjectOnlineOrOffline
export function trainProjectOnlineOrOffline(params) {
  return request({
    url: '/train/trainProjectOnlineOrOffline',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询分页培训班教室信息
// GET /train/getPageTrainRoom
export function getPageTrainRoom(params) {
  return request({
    url: '/train/getPageTrainRoom',
    method: 'get',
    params: params,
  })
}
// 查询培训班教室信息
// GET /train/getTrainRoom
export function getTrainRoom(params) {
  return request({
    url: '/train/getTrainRoom',
    method: 'get',
    params: params,
  })
}
// 新增培训班教室信息
// POST /train/insertTrainRoom
export function insertTrainRoom(params) {
  return request({
    url: '/train/insertTrainRoom',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 修改培训班教室信息
// POST /train/updateTrainRoom
export function updateTrainRoom(params) {
  return request({
    url: '/train/updateTrainRoom',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 删除培训班教室信息
// POST /train/deleteTrainRoom
export function deleteTrainRoom(params) {
  return request({
    url: '/train/deleteTrainRoom',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 编辑时查询项目信息
// GET /train/getTrainProjectInfo
export function getTrainProjectInfo(params) {
  return request({
    url: '/train/getTrainProjectInfo',
    method: 'get',
    params: params,
  })
}
// 根据项目id查询项目回显信息
// GET /train/getTrainProjectInfoById
export function getTrainProjectInfoById(params) {
  return request({
    url: '/train/getTrainProjectInfoById',
    method: 'get',
    params: params,
  })
}
// 新增班级详细信息
// POST /train/addTrainClassInfo
export function addTrainClassInfo(params) {
  return request({
    url: '/train/addTrainClassInfo',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询培训班班级信息
// GET /train/getTrainClassInfo
export function getTrainClassInfo(params) {
  return request({
    url: '/train/getTrainClassInfo',
    method: 'get',
    params: params,
  })
}
// 修改班级详细信息
// POST /train/updateTrainClassInfo
export function updateTrainClassInfo(params) {
  return request({
    url: '/train/updateTrainClassInfo',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 根据项目ID或者班级Id查看班内人员
// GET /train/getClassStudent
export function getClassStudent(params) {
  return request({
    url: '/train/getClassStudent',
    method: 'get',
    params: params,
  })
}
// 批量添加学员
// POST /train/addClassStudent
export function addClassStudent(params) {
  return request({
    url: '/train/addClassStudent',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 移除学员
// POST /train/updateClassStudent
export function updateClassStudent(params) {
  return request({
    url: '/train/updateClassStudent',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 批量项目变更
// POST /train/updateStudentOfProject
export function updateStudentOfProject(params) {
  return request({
    url: '/train/updateStudentOfProject',
    method: 'post',
    data: Qs.stringify(params),
  })
}

// 查询会员卡支付类型
// GET /card/getCardPayType
export function getCardPayType(params) {
  return request({
    url: '/card/getCardPayType',
    method: 'get',
    params: params,
  })
}
// 查询分店会员卡支付类型
// GET /card/getShopCardPayType
export function getShopCardPayType(params) {
  return request({
    url: '/card/getShopCardPayType',
    method: 'get',
    params: params,
  })
}
// 增加分店会员卡支付类型
// POST /card/insertShopCardPayType
export function insertShopCardPayType(params) {
  return request({
    url: '/card/insertShopCardPayType',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 修改分店会员卡支付类型
// POST /card/updateShopCardPayType
export function updateShopCardPayType(params) {
  return request({
    url: '/card/updateShopCardPayType',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 删除分店会员卡支付类型
// POST /card/deleteShopCardPayType
export function deleteShopCardPayType(params) {
  return request({
    url: '/card/deleteShopCardPayType',
    method: 'post',
    data: Qs.stringify(params),
  })
}

//获取产品类型
//GET /interalOffer/interalOfferGetProductType
export function interalOfferGetProductType(params) {
  return request({
    url: 'interalOffer/getProductType',
    method: 'get',
    params: params,
  })
}
// 新增内部优惠
// POST /interalOffer/insertInternalOffer
export function insertInternalOffer(params) {
  return request({
    url: '/interalOffer/insertInternalOffer',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 修改内部优惠
// POST /interalOffer/updateInternalOffer
export function updateInternalOffer(params) {
  return request({
    url: '/interalOffer/updateInternalOffer',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//查询内部优惠
//GET /interalOffer/getInternalOffer
export function getInternalOffer(params) {
  return request({
    url: 'interalOffer/getInternalOffer',
    method: 'get',
    params: params,
  })
}
// 内部优惠上下架
// POST /interalOffer/updateInternalOfferType
export function updateInternalOfferType(params) {
  return request({
    url: '/interalOffer/updateInternalOfferType',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 删除内部优惠
// POST /interalOffer/deleteInternalOffer
export function deleteInternalOffer(params) {
  return request({
    url: '/interalOffer/deleteInternalOffer',
    method: 'post',
    data: Qs.stringify(params),
  })
}
//根据类型查询票名称
//GET /interalOffer/getTicketInfo
export function getTicketInfo(params) {
  return request({
    url: '/interalOffer/getTicketInfo',
    method: 'get',
    params: params,
  })
}
//设置场馆会员卡二维码设置
//POST /card/addCodeConfiguration
export function addCodeConfiguration(params) {
  return request({
    url: '/card/addCodeConfiguration',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询场馆会员卡二维码设置
//GET /card/getCodeConfiguration
export function getCodeConfiguration(params) {
  return request({
    url: '/card/getCodeConfiguration',
    method: 'get',
    params: params,
  })
}
// 查询数据源分店信息
// GET /venue/getSourceShops
export function getSourceShops(params) {
  return request({
    url: '/venue/getSourceShops',
    method: 'get',
    params: params,
  })
}

// 添加项目与三级分类关联
// POST /attrcategory/insertAttrCategory
export function insertAttrCategory(params) {
  return request({
    url: '/attrcategory/insertAttrCategory',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 添加园区分馆下项目占比
// POST /attrcategory/insertAttrRatio
export function insertAttrRatio(params) {
  return request({
    url: '/attrcategory/insertAttrRatio',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 删除项目与三级分类关联
// POST /attrcategory/deleteAttrCategory
export function deleteAttrCategory(params) {
  return request({
    url: '/attrcategory/deleteAttrCategory',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询项目类型下的所有项目
// GET /attrcategory/selectInfAll
export function selectInfAll(params) {
  return request({
    url: '/attrcategory/selectInfAll',
    method: 'get',
    params: params,
  })
}
// 查询三级分类树
// GET /attrcategory/selectItemRatio
export function selectItemRatio(params) {
  return request({
    url: '/attrcategory/selectItemRatio',
    method: 'get',
    params: params,
  })
}
// 查询项目类型
// GET /attrcategory/selectAllType
export function selectAllType(params) {
  return request({
    url: '/attrcategory/selectAllType',
    method: 'get',
    params: params,
  })
}
// 查询关联好的项目
// GET /attrcategory/selectCategoryAll
export function selectCategoryAll(params) {
  return request({
    url: '/attrcategory/selectCategoryAll',
    method: 'get',
    params: params,
  })
}
// 查询关联好的项目无分页
// GET /attrcategory/selectCategoryAllNoPage
export function selectCategoryAllNoPage(params) {
  return request({
    url: '/attrcategory/selectCategoryAllNoPage',
    method: 'get',
    params: params,
  })
}
// 查询项目占比
// GET /attrcategory/selectAttrItemRatio
export function selectAttrItemRatio(params) {
  return request({
    url: '/attrcategory/selectAttrItemRatio',
    method: 'get',
    params: params,
  })
}
// 删除项目与三级分类关联
// POST /attrcategory/deleteAttrItemRatio
export function deleteAttrItemRatio(params) {
  return request({
    url: '/attrcategory/deleteAttrItemRatio',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 查询押金
// GET /report/selectDeposit
export function selectDeposit(params) {
  return request({
    url: '/report/selectDeposit',
    method: 'get',
    params: params,
  })
}
// 获取新的销售日报表表头
// GET /report/getNewSalesDayReportTbaleHaed
export function getNewSalesDayReportTbaleHaed(params) {
  return request({
    url: '/report/getNewSalesDayReportTbale',
    method: 'get',
    params: params,
  })
}
// 退卡明细
// GET /report/refundCardHistory
export function refundCardHistory(params) {
  return request({
    url: '/report/refundCardHistory',
    method: 'get',
    params: params,
  })
}
// 运动交款单
//GET /report/motionPayment
export function motionPayment(params) {
  return request({
    url: '/report/motionPayment',
    method: 'get',
    params: params,
  })
}
// 查询园区统计时间
//GET /report/getRePortTime
export function getRePortTime(params) {
  return request({
    url: '/report/getRePortTime',
    method: 'get',
    params: params,
  })
}
// 删除园区统计时间
//POST /report/deleteRePortTime
export function deleteRePortTime(params) {
  return request({
    url: '/report/deleteRePortTime',
    method: 'post',
    data: Qs.stringify(params),
  })
}
// 修改/增加园区统计时间
//POST /report/insertRePortTime
export function insertRePortTime(params) {
  return request({
    url: '/report/insertRePortTime',
    method: 'post',
    data: Qs.stringify(params),
  })
}


// WEBPACK FOOTER //
// ./src/api/configApi.js